import { render, staticRenderFns } from "./PointSchedulesMaintenance.vue?vue&type=template&id=e4c00852"
import script from "./PointSchedulesMaintenance.vue?vue&type=script&lang=ts"
export * from "./PointSchedulesMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports